/**
 * The few glyphs the portal draws. Inline SVG (no icon font, no request),
 * `currentColor` so they take the role colour around them, and always
 * `aria-hidden`: every icon sits beside words that say the same thing.
 */
type P = { className?: string };

const base = {
  width: 16,
  height: 16,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
  focusable: false,
};

export const SearchIcon = (p: P) => (
  <svg {...base} className={p.className}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </svg>
);

export const LockIcon = (p: P) => (
  <svg {...base} className={p.className}>
    <rect x="4" y="11" width="16" height="10" rx="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </svg>
);

export const CheckIcon = (p: P) => (
  <svg {...base} className={p.className}>
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

export const ClockIcon = (p: P) => (
  <svg {...base} className={p.className}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);

export const ChevronLeft = (p: P) => (
  <svg {...base} className={p.className}>
    <path d="m15 18-6-6 6-6" />
  </svg>
);

export const ArrowLeft = (p: P) => (
  <svg {...base} className={p.className}>
    <path d="M19 12H5" />
    <path d="m12 19-7-7 7-7" />
  </svg>
);

export const ChevronRight = (p: P) => (
  <svg {...base} className={p.className}>
    <path d="m9 18 6-6-6-6" />
  </svg>
);

export const FilmIcon = (p: P) => (
  <svg {...base} className={p.className}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M7 4v16M17 4v16M3 9h4M3 15h4M17 9h4M17 15h4" />
  </svg>
);

export const PlusIcon = (p: P) => (
  <svg {...base} className={p.className}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export const StarIcon = (p: P) => (
  <svg {...base} className={p.className} fill="currentColor" stroke="none">
    <path d="m12 2.8 2.8 5.9 6.4.8-4.7 4.4 1.2 6.4L12 17.2l-5.7 3.1 1.2-6.4-4.7-4.4 6.4-.8z" />
  </svg>
);

export const HomeIcon = (p: P) => (
  <svg {...base} className={p.className}>
    <path d="M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z" />
  </svg>
);

export const BookmarkIcon = (p: P) => (
  <svg {...base} className={p.className}>
    <path d="M6 3h12v18l-6-4-6 4z" />
  </svg>
);

/** A ticket with a check: the organisation's plan (ORG-5). */
export const PlanIcon = (p: P) => (
  <svg {...base} className={p.className}>
    <path d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 0 0 6v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-6z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

/** A door with an arrow out: sign out. */
export const LogoutIcon = (p: P) => (
  <svg {...base} className={p.className}>
    <path d="M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" />
    <path d="M10 16l-4-4 4-4" />
    <path d="M6 12h10" />
  </svg>
);

export const UserIcon = (p: P) => (
  <svg {...base} className={p.className}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21a8 8 0 0 1 16 0" />
  </svg>
);

export const DocumentIcon = (p: P) => (
  <svg {...base} className={p.className}>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <path d="M14 3v5h5M9 13h6M9 17h4" />
  </svg>
);

export const PlayIcon = (p: P) => (
  <svg {...base} className={p.className} fill="currentColor" stroke="none">
    <path d="M7 4l13 8-13 8z" />
  </svg>
);
